import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { ownerFieldsFragment } from './ownerFieldsFragment';

export const evaluationSummaryFieldsFragment = gql`
  fragment AdminEvaluationSummaryFields on Evaluation {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    owner {
      ...AdminOwnerFields
    }
    name
    description
    categories { _ref }
    questions { _ref }
    options {
      enableTimer
    }
  }

  ${sanityDocumentFieldsFragment}
  ${ownerFieldsFragment}
`;